'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('../utils'),
    withTimeoutOption = _require.withTimeoutOption;

var errCode = require('err-code');

module.exports = function (_ref) {
  var libp2p = _ref.libp2p;
  return {
    subscribe: withTimeoutOption(function () {
      var _libp2p$pubsub;

      return (_libp2p$pubsub = libp2p.pubsub).subscribe.apply(_libp2p$pubsub, arguments);
    }),
    unsubscribe: withTimeoutOption(function () {
      var _libp2p$pubsub2;

      return (_libp2p$pubsub2 = libp2p.pubsub).unsubscribe.apply(_libp2p$pubsub2, arguments);
    }),
    publish: withTimeoutOption( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(topic, data, options) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _context.next = 2;
                  break;
                }

                throw errCode(new Error('argument "data" is required'), 'ERR_ARG_REQUIRED');

              case 2:
                _context.next = 4;
                return libp2p.pubsub.publish(topic, data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }()),
    ls: withTimeoutOption(function () {
      var _libp2p$pubsub3;

      return (_libp2p$pubsub3 = libp2p.pubsub).getTopics.apply(_libp2p$pubsub3, arguments);
    }),
    peers: withTimeoutOption(function () {
      var _libp2p$pubsub4;

      return (_libp2p$pubsub4 = libp2p.pubsub).getSubscribers.apply(_libp2p$pubsub4, arguments);
    })
  };
};